<script setup lang="ts">
import UserInfo from '../UserInfo.vue';
import { SidebarNav } from '../navigation';
</script>

<template>
    <nav class="sidebar-box">
        <UserInfo type="panel" />
        <ClientOnly>
            <SidebarNav />
        </ClientOnly>
    </nav>
</template>

<style scoped lang="scss">
.sidebar-box {
    border-radius: 10px;
    width: 100%;
    overflow: hidden;
    @include shadow();
}
</style>
